import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ExitButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	SetToPendingButton,
	ApproveQualityButton,
	QualityCheckFiles,
	RetailOrderCommunicationButton,
	ChangeOrderButton,
	RetailOrderProgressStep,
	ViewChangeRequestButton
} from '../../../features/cfi/retail-order';
import { FileTypes } from '../../../types/enums';
import '../../../css/order.scss';


export default function QualityCheckPage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<ApproveQualityButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton defaultFileType={FileTypes.CabinetQualityCheckWorksheet} />
						</ToolbarItem>
						<ToolbarItem>
							<SetToPendingButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.QualityCheck} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.QualityCheck} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<RetailOrderDatesPanel
						showScheduledInstallDates={true}
					/>
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<QualityCheckFiles />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
